import { Button, Container, Typography } from "@mui/material";
import useIsMobile from '../App.helper';

export interface EndScreenProps{
    score:number
    newGame: ()=>void
}

const EndScreen = (props:EndScreenProps)=> {
        const isMobile = useIsMobile()

    const getCommentaryOnGameplay=()=>{
        let commentary =''
        if (props.score<0){
            commentary ='Do you even know what Steam is?'
        }
        if(props.score===0){
            commentary= 'Wow! thats somehow worse than scoring minus points!'
        }
        if(props.score>0 && props.score<5){
            commentary='You can do better'
        }
         if(props.score>=5 && props.score<10){
            commentary='So close'
        }
         if(props.score===10){
            commentary='Well done! You know your Steam'
        }
        return commentary
    }

    const handleNewGame =()=>{
        props.newGame()
    }

    const handlePlayWithAnotherAccount =()=>{
        window.location.reload();
    }


     return (
        <Container>
            <Typography variant={!isMobile ? 'h2':'h5'} marginBottom={'1rem'}>You Scored: {props.score}</Typography>
            <Typography>{getCommentaryOnGameplay()}</Typography>
            <Button size={!isMobile ? 'large':'small'}  onClick={()=>handleNewGame()}>New game</Button>
            <Button size={!isMobile ? 'large':'small'}  onClick={()=>handlePlayWithAnotherAccount()}>Play with another account</Button>
        </Container>
    )
}

export default EndScreen